import React from 'react';

export default function TermsOfService({ onClose }) {
  return (
    <div className="fixed inset-0 z-[100] bg-black/70 flex items-center justify-center p-4">
      <div className="bg-slate-900 border border-slate-700 rounded-xl max-w-2xl w-full max-h-[85vh] flex flex-col">
        <div className="flex items-center justify-between px-5 py-4 border-b border-slate-800">
          <h2 className="text-lg font-bold text-white">Terms of Service</h2>
          {onClose && (
            <button onClick={onClose} className="text-slate-500 hover:text-white text-xl leading-none">&times;</button>
          )}
        </div>
        <div className="overflow-y-auto px-5 py-4 text-sm text-slate-300 space-y-4 scrollbar-thin">
          <p className="text-[10px] text-slate-500">Effective April 1, 2026 &mdash; Valhalla Systems LLC</p>

          <Section title="1. Acceptance">
            By registering on the THANE Protocol marketplace, you agree to be bound by these Terms. Registration requires explicit acceptance via checkbox.
          </Section>

          <Section title="2. Prohibited Content and Services">
            <p>You shall not list, offer, or deliver through the Protocol any content or service that:</p>
            <ul className="list-disc pl-5 space-y-1 mt-2 text-slate-400">
              <li>Violates any applicable law or regulation</li>
              <li>Facilitates illegal activity (money laundering, fraud, sanctions evasion, terrorism financing)</li>
              <li>Contains or facilitates CSAM or exploitation of minors</li>
              <li>Provides tools for unauthorized computer access (excluding legitimate security research)</li>
              <li>Distributes malware, ransomware, or stolen data</li>
              <li>Facilitates harassment, doxxing, or threats of violence</li>
              <li>Promotes discrimination based on protected characteristics</li>
              <li>Impersonates other entities or individuals</li>
              <li>Violates export control laws</li>
            </ul>
          </Section>

          <Section title="3. Public On-Chain Transactions">
            All listings, settlements, disputes, and reputation scores are recorded on the Solana blockchain and are permanently public. Transaction amounts, wallet addresses, and history cannot be deleted. You should not use the Protocol if you require transaction privacy.
          </Section>

          <Section title="4. Community Flagging">
            Any participant may flag violations through the dispute system (requires staking collateral). The Protocol authority reviews evidence and resolves disputes. Losing party forfeits collateral (70% to winner, 30% to treasury). Providers with unresolved violations may be delisted.
          </Section>

          <Section title="5. Fees">
            Native escrow: 3% fee (1.5% with $THANE). External rails: monthly listing fee. 30% of fees burned permanently. Subscription cancellations do not include refunds.
          </Section>

          <Section title="6. Disclaimers">
            THE PROTOCOL IS PROVIDED "AS IS" WITHOUT WARRANTIES. Valhalla Systems LLC is not liable for provider failures, smart contract vulnerabilities, token value changes, or blockchain downtime. $THANE is a utility token, not an investment.
          </Section>

          <Section title="7. Governing Law">
            These Terms are governed by the laws of the State of Arizona, United States. Disputes shall be resolved in Pima County, Arizona courts.
          </Section>

          <p className="text-[10px] text-slate-500 pt-2 border-t border-slate-800">
            Full terms available at <a href="/terms" className="text-purple-400 hover:text-purple-300">thane.market/terms</a> and in the <a href="https://github.com/KK6BZB/thane-protocol/blob/master/TERMS.md" target="_blank" rel="noreferrer" className="text-purple-400 hover:text-purple-300">repository</a>.
          </p>
        </div>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div>
      <h3 className="text-xs font-semibold text-white uppercase tracking-wider mb-1">{title}</h3>
      <div className="text-slate-400 text-xs leading-relaxed">{children}</div>
    </div>
  );
}

export function TOSCheckbox({ accepted, onChange }) {
  const [showTOS, setShowTOS] = React.useState(false);
  return (
    <>
      <label className="flex items-start gap-2 cursor-pointer">
        <input
          type="checkbox"
          checked={accepted}
          onChange={e => onChange(e.target.checked)}
          className="mt-0.5 rounded border-slate-600 bg-slate-800 text-purple-500 focus:ring-purple-500/30"
        />
        <span className="text-xs text-slate-400">
          I agree to the{' '}
          <button type="button" onClick={() => setShowTOS(true)} className="text-purple-400 hover:text-purple-300 underline">
            Terms of Service
          </button>
          , including the prohibited use policy and acknowledgment that all transactions are public and on-chain.
        </span>
      </label>
      {showTOS && <TermsOfService onClose={() => setShowTOS(false)} />}
    </>
  );
}
